import React from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Stack,
    TextField,
} from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

import { AGE_BUCKET_OPTIONS, ageBucketMeta } from '../../../dto/openInvoice';
import AppDatePicker from '../../shared/AppDatePicker';

export default function OpenInvoiceFilters({
    filters,
    levels,
    onFilterChange,
    onDateChange,
    onApply,
    onReset,
}) {
    return (
        <Card>
            <CardContent>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} useFlexGap flexWrap>
                    <FormControl sx={{ minWidth: 220 }}>
                        <InputLabel id="bucket-select-label">Fälligkeits-Buckets</InputLabel>
                        <Select
                            labelId="bucket-select-label"
                            multiple
                            value={filters.buckets}
                            onChange={onFilterChange('buckets')}
                            input={<OutlinedInput label="Fälligkeits-Buckets" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={ageBucketMeta[value]?.label || value} size="small" />
                                    ))}
                                </Box>
                            )}
                        >
                            {AGE_BUCKET_OPTIONS.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 220 }}>
                        <InputLabel id="level-select-label">Mahnstufe</InputLabel>
                        <Select
                            labelId="level-select-label"
                            value={filters.level}
                            label="Mahnstufe"
                            onChange={onFilterChange('level')}
                        >
                            <MenuItem value="">Alle</MenuItem>
                            <MenuItem value="none">Ohne Mahnstufe</MenuItem>
                            {levels.map((level) => (
                                <MenuItem key={level.id} value={level.id}>
                                    {level.subject || `Mahnstufe nach ${level.daysAfterDue} Tagen`}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <AppDatePicker
                        label="Fällig ab"
                        value={filters.dueFrom}
                        onChange={onDateChange('dueFrom')}
                        sx={{ minWidth: 180 }}
                    />
                    <AppDatePicker
                        label="Fällig bis"
                        value={filters.dueTo}
                        onChange={onDateChange('dueTo')}
                        sx={{ minWidth: 180 }}
                    />
                    <TextField
                        label="Kunde"
                        value={filters.customer}
                        onChange={onFilterChange('customer')}
                        sx={{ minWidth: 220 }}
                    />
                    <Stack direction="row" spacing={1} sx={{ alignSelf: 'center' }}>
                        <Button variant="contained" startIcon={<RefreshRoundedIcon />} onClick={onApply}>
                            Filter anwenden
                        </Button>
                        <Button variant="text" onClick={onReset}>
                            Zurücksetzen
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
